import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDialog } from '@cnx-saas/common-fe';

import { useKeycloakAuth } from '@cnx-saas/react-auth';
import { useSnackbar } from '@cnx-saas/snackbar';
import { useGetMeQuery } from '../../api/tenant';
import { usePasswordResetUpdateMutation } from '../../api/tenant/mutations/reset-password';
import {
  ChangePasswordForm,
  ChangePasswordFormInput,
} from './change-password-form';

export function useChangePassword() {
  const { t } = useTranslation();
  const { openDialog, closeDialog } = useDialog();
  const { addAlert } = useSnackbar();

  const [resetPassword] = usePasswordResetUpdateMutation();
  const keycloakAuth = useKeycloakAuth();
  const getMe = useGetMeQuery();
  function openChangePasswordFormDialog() {
    const id = 'change-password-dialog';
    openDialog({
      id,
      title: t('userManagement.form.changePassword', {
        defaultValue: 'Change Password',
      }),
      content: (
        <ChangePasswordForm
          onClose={() => closeDialog(id)}
          onSubmit={async ({
            password,
            newPassword,
          }: ChangePasswordFormInput) => {
            if (!getMe.data?.getMe.email) return;
            try {
              await keycloakAuth.login(getMe.data?.getMe.email, password);
              const { data, errors } = await resetPassword({
                variables: {
                  details: {
                    password: newPassword,
                    email: getMe.data?.getMe.email,
                  },
                },
              });
              if (errors || data?.resetPassword.message !== 'ok') {
                addAlert({
                  type: 'error',
                  children: data?.resetPassword.message,
                });
              } else {
                addAlert({
                  type: 'success',
                  children: t('userManagement.resetPassword.success', {
                    defaultValue: 'Password has been changed',
                  }),
                });
                closeDialog(id);
              }
            } catch {
              addAlert({
                type: 'error',
                children: t('userManagement.resetPassword.incorrectPassword', {
                  defaultValue: 'Current password is incorrect',
                }),
              });
              return;
            }
          }}
        />
      ),
    });
  }
  return { openChangePasswordFormDialog };
}
